import { onBeforeUnmount, ref } from 'vue'

/**
 * Generic reactive media query. Used for the 900px nav breakpoint that
 * support.js handled with a resize listener rewriting `cssText`.
 *
 * @param {string} query
 * @returns {import('vue').Ref<boolean>}
 */
export function useMediaQuery(query) {
  const matches = ref(false)

  if (typeof window !== 'undefined' && window.matchMedia) {
    const mql = window.matchMedia(query)
    matches.value = mql.matches

    const onChange = (event) => {
      matches.value = event.matches
    }

    mql.addEventListener('change', onChange)
    onBeforeUnmount(() => mql.removeEventListener('change', onChange))
  }

  return matches
}
